<p class="text-center">

    <img src="/assets/images/coming-soon.png">

</p>
